import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputT from '@components/tailwind-components/Input/InputT';
import { t } from 'i18next';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from '../../../hooks/modal/useModal';
import { useRevisionsActions } from '../useRevisionsActions';

export const RevisionAddModal = () => {
  const { hideModal } = useModal();
  const { createRevision } = useRevisionsActions();

  const { handleSubmit, control } = useForm({
    defaultValues: {
      revisionTitle: '',
    },
    shouldUseNativeValidation: true,
  });

  const hideAndSubmit = useCallback(
    (data: { revisionTitle: string }) => {
      createRevision(data.revisionTitle);
      hideModal();
    },
    [createRevision, hideModal],
  );

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputT
              field='revisionTitle'
              type='text'
              placeholder={t('settings.revision.title')}
              control={control}
              options={{
                required: t('general.validation.required'),
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
